import { useRef } from "react";
import {
  useExternalTrainingQuery,
  useExternalTrainingQueryRejected,
  useExternalTrainingQueryApproved
} from "../../queries/externalTrainingSkillbook";
import {
  useCourseTypesOptionsQuery,
  useGetExternalCertificateRequests,
  useGetExternalCertificateRequestsApproved,
  useGetExternalCertificateRequestsRejected
} from "../../queries/skillbook";
import {
  GetPayloadPropsExternal,
  GetPayloadPropsExternalTraining
} from "../../routes/Profile/ExternalTrainingAddSkillbook/AddSkillBook.types";
import { DataResponse } from "components/InputCst/MultiSelectCst/types";

export const useExternalTrainingData = (

  userId: string | number,
  corporateId: string | number,
  name: string,
  surname: string,
  setCourses: React.Dispatch<React.SetStateAction<CourseItem[]>>,
  mergeCourses: (prev: CourseItem[], next: CourseItem[]) => CourseItem[],
  refreshKey?: number
  // TODO: scommentare quando il backend supporterà i filtri
  // statusFilter?: CourseStatusFilter,
  // typeFilter?: CourseTypeFilter,
  // sortBy?: string,          // ordinamento per colonna (status, type, startDate)
  // sortDirection?: "asc" | "desc"
) => {

  const enabled = !!userId && !!corporateId && refreshKey !== undefined;

  const modeMapV2 = useRef<Record<string, string>>({});

  useCourseTypesOptionsQuery({
    onError: (error) => {
      console.error("Error fetching data Course Types:", error);
    },
    onSuccess: (data: unknown) => {
      modeMapV2.current = (data as DataResponse[]).reduce((acc, item) => {
        const label = item.name || item.label || "";
        [item.id, item.value]
          .filter((k) => k != null)
          .forEach((k) => (acc[String(k)] = label));
        return acc;
      }, {} as Record<string, string>);
    }
  });


  // ─── 1) PENDING - CERTIFICATE REQUEST ───
  //    Query key: ["externalCert", userId, "pending"]
  useGetExternalCertificateRequests({
    queryKey: ["externalCert", String(userId), "pending", String(refreshKey)],
    queryParams: {
      visibility: 1,
      learnerId: userId,
      corporateId,
      name,
      surname,
      status: "pending"
      // TODO: scommentare quando il backend supporterà i filtri
      // statusFilter,     // CourseStatusFilter
      // typeFilter,        // CourseTypeFilter
      // sortBy,            // colonna di ordinamento
      // sortDirection      // direzione ordinamento
    },
    enabled,
    onSuccess: (data: { content: GetPayloadPropsExternal[] }) => {
      console.log("dati corsi 1:", data.content);
      const mappedCourses: CourseItem[] = data.content
        .sort((a, b) => Number(b.id) - Number(a.id))
        .map(item => {
          const status: CourseItem["status"] =
            item.status === "APPROVED"  ? "APPROVED"  :
              item.status === "REJECTED"  ? "REJECTED"  :
                "PENDING";


          return {
            id: item.id,
            title: item.title,
            description: item.description,
            provider: item.provider ?? "-",
            startDate: item.courseStartDate ?? "",
            endDate: item.courseEndDate ?? "",
            status,
            type: item.type ?? "Consuntivazione",
            duration: Number(item.duration),
            durationParticipation: Number(item.durationParticipation),
            source: item.source,
            area: Array.isArray(item.area) ? item.area : null,
            location: item.location,
            trainingMode: modeMapV2.current[String(item.trainingMode ?? item.typeId)] ?? "",
            cost: item.cost,
            certificateStartValidityDate: item.certificateStartValidityDate,
            certificateEndValidityDate: item.certificateEndValidityDate,
            pdfKey: item.pdfKey,
            certificate_url: item.url,
            instructor: item.instructor,
            capability: Array.isArray(item.capability)? item.capability.map((c) => ({ id: Number(c.id), label: c.label })): [],
            campaign: item.campaign ?? "",
            campaignId: item.campaignId != null ? String(item.campaignId) : "",
            createdBy: item.createdBy,
            updatedBy: item.updatedBy ?? null,
            customFields: item.customFields ?? []
          };
        });
      setCourses(prev => mergeCourses(prev, mappedCourses));
    },
    onError: error => {
      console.error("Errore recupero corsi pending certificate:", error);
    }
  });

  // ─── 2) APPROVED - CERTIFICATE REQUEST ───
  //    Query key: ["externalCert", userId, "approved"]
  useGetExternalCertificateRequestsApproved({
    queryKey: ["externalCert", String(userId), "APPROVED", String(refreshKey)],
    queryParams: {
      visibility: 1,
      learnerId: userId,
      corporateId,
      name,
      surname,
      status: "APPROVED"
      // TODO: scommentare quando il backend supporterà i filtri
      // statusFilter, typeFilter, sortBy, sortDirection
    },
    enabled,
    onSuccess: (data: { content: GetPayloadPropsExternal[] }) => {
      console.log("dati corsi 2:", data.content);
      const mappedCourses: CourseItem[] = data.content
        .sort((a, b) => Number(b.id) - Number(a.id))
        .map(item => {
          const status: CourseItem["status"] =
            item.status === "APPROVED"  ? "APPROVED"  :
              item.status === "REJECTED"  ? "REJECTED"  :
                "PENDING";

          return {
            id: Number(item.id),
            title: item.title,
            description: item.description,
            provider: item.provider ?? "-",
            startDate: item.courseStartDate ?? "",
            endDate: item.courseEndDate ?? "",
            status,
            type: item.type ?? "Consuntivazione",
            duration: Number(item.duration),
            durationParticipation: Number(item.durationParticipation),
            source: item.source,
            area: Array.isArray(item.area) ? item.area : null,
            location: item.location,
            trainingMode: modeMapV2.current[String(item.trainingMode ?? item.typeId)] ?? "",
            cost: item.cost,
            certificateStartValidityDate: item.certificateStartValidityDate,
            certificateEndValidityDate: item.certificateEndValidityDate,
            pdfKey: item.pdfKey,
            certificate_url: item.url,
            instructor: item.instructor,
            capability: Array.isArray(item.capability)? item.capability.map((c) => ({ id: Number(c.id), label: c.label })): [],
            campaign: item.campaign ?? "",
            campaignId: item.campaignId != null ? String(item.campaignId) : "",
            createdBy: item.createdBy,
            updatedBy: item.updatedBy ?? null,
            customFields: item.customFields ?? []
          };
        });
      setCourses(prev => mergeCourses(prev, mappedCourses));
    },
    onError: error => {
      console.error("Errore recupero corsi approved certificate:", error);
    }
  });

  // ─── 3) REJECTED - CERTIFICATE REQUEST ───
  //    Query key: ["externalCert", userId, "rejected"]
  useGetExternalCertificateRequestsRejected({
    queryKey: ["externalCert", String(userId), "rejected", String(refreshKey)],
    queryParams: {
      visibility: 1,
      learnerId: userId,
      corporateId,
      name,
      surname,
      status: "REJECTED"
      // TODO: scommentare quando il backend supporterà i filtri
      // statusFilter, typeFilter, sortBy, sortDirection
    },
    enabled,
    onSuccess: (data: { content: GetPayloadPropsExternal[] }) => {
      console.log("dati corsi 3:", data.content);
      const mappedCourses: CourseItem[] = data.content
        .sort((a, b) => Number(b.id) - Number(a.id))
        .map(item => {
          const status: CourseItem["status"] =
            item.status === "APPROVED"  ? "APPROVED"  :
              item.status === "REJECTED"  ? "REJECTED"  :
                "PENDING";

          return {
            id: Number(item.id),
            title: item.title,
            description: item.description,
            provider: item.provider ?? "-",
            startDate: item.courseStartDate ?? "",
            endDate: item.courseEndDate ?? "",
            status,
            type: item.type ?? "Consuntivazione",
            duration: Number(item.duration),
            durationParticipation: Number(item.durationParticipation),
            source: item.source,
            area: Array.isArray(item.area) ? item.area : null,
            location: item.location,
            trainingMode: modeMapV2.current[String(item.trainingMode ?? item.typeId)] ?? "",
            certificate_url: item.url,
            cost: item.cost,
            certificateStartValidityDate: item.certificateStartValidityDate,
            certificateEndValidityDate: item.certificateEndValidityDate,
            pdfKey: item.pdfKey,
            instructor: item.instructor,
            capability: Array.isArray(item.capability)? item.capability.map((c) => ({ id: Number(c.id), label: c.label })): [],
            campaign: item.campaign ?? "",
            campaignId: item.campaignId != null ? String(item.campaignId) : "",
            createdBy: item.createdBy,
            updatedBy: item.updatedBy ?? null,
            customFields: item.customFields ?? []

          };
        });
      setCourses(prev => mergeCourses(prev, mappedCourses));
    },
    onError: error => {
      console.error("Errore recupero corsi rejected certificate:", error);
    }
  });

  // ─── 4) PENDING - TRAINING REQUEST ───
  //    Query key: ["externalTrain", userId, "pending"]
  useExternalTrainingQuery({
    queryKey: ["externalTrain", String(userId), "pending", String(refreshKey)],
    queryParams: {
      learnerId: userId,
      corporateId,
      name,
      surname,
      status: "pending"
      // TODO: scommentare quando il backend supporterà i filtri
      // statusFilter, typeFilter, sortBy, sortDirection
    },
    enabled,
    onSuccess: (data: { content: GetPayloadPropsExternalTraining[] }) => {
      console.log("dati corsi 4:", data.content);
      const mappedCourses: CourseItem[] = data.content
        .sort((a, b) => Number(b.id) - Number(a.id))
        .map(item => {
          const status: CourseItem["status"] =
            item.status === "APPROVED"  ? "APPROVED"  :
              item.status === "REJECTED"  ? "REJECTED"  :
                "PENDING";

          return {
            id: Number(item.id),
            title: item.title,
            provider: item.provider ?? "-",
            startDate: item.startDate ?? "",
            endDate: item.endDate ?? "",
            status,
            type: item.type ?? "Iscrizione",
            duration: Number(item.durationMinutes),
            durationParticipation: Number(item.durationParticipation) ?? 0,
            source: item.source,
            area: Array.isArray(item.area) ? item.area : null,
            location: item.location,
            cost: item.cost,
            motivation: item.motivation,
            capability: Array.isArray(item.capability)? item.capability.map((c) => ({ id: Number(c.id), label: c.label })): [],
            businessTrip: item.businessTrip,
            campaign: item.campaign ?? "",
            instructor: item.instructor,
            trainingMode: modeMapV2.current[item.trainingMode] ?? "",
            plan: item.plan,
            description: item.description,
            campaignId: item.campaignId != null ? String(item.campaignId) : "",
            createdBy: item.createdBy,
            updatedBy: item.updatedBy ?? null,
            customFields: item.customFields ?? []
          };
        });
      setCourses(prev => mergeCourses(prev, mappedCourses));
    },
    onError: error => {
      console.error("Errore recupero corsi pending training:", error);
    }
  });

  // ─── 5) REJECTED - TRAINING REQUEST ───
  //    Query key: ["externalTrain", userId, "rejected"]
  useExternalTrainingQueryRejected({
    queryKey: ["externalTrain", String(userId), "rejected", String(refreshKey)],
    queryParams: {
      learnerId: userId,
      corporateId,
      name,
      surname,
      status: "rejected"
      // TODO: scommentare quando il backend supporterà i filtri
      // statusFilter, typeFilter, sortBy, sortDirection
    },
    enabled,
    onSuccess: (data: { content: GetPayloadPropsExternalTraining[] }) => {
      console.log("dati corsi 5:", data.content);
      const mappedCourses: CourseItem[] = data.content
        .sort((a, b) => Number(b.id) - Number(a.id))
        .map(item => {
          const status: CourseItem["status"] =
            item.status === "APPROVED"  ? "APPROVED"  :
              item.status === "REJECTED"  ? "REJECTED"  :
                "PENDING";

          return {
            id: Number(item.id),
            title: item.title,
            provider: item.provider ?? "-",
            startDate: item.startDate ?? "",
            endDate: item.endDate ?? "",
            status,
            type: item.type ?? "Iscrizione",
            duration: Number(item.durationMinutes),
            durationParticipation: Number(item.durationParticipation),
            source: item.source,
            area: Array.isArray(item.area) ? item.area : null,
            location: item.location,
            cost: item.cost,
            motivation: item.motivation,
            capability: Array.isArray(item.capability)? item.capability.map((c) => ({ id: Number(c.id), label: c.label })): [],
            businessTrip: item.businessTrip,
            campaign: item.campaign ?? "",
            instructor: item.instructor,
            trainingMode: modeMapV2.current[item.trainingMode] ?? "",
            plan: item.plan,
            description: item.description,
            campaignId: item.campaignId != null ? String(item.campaignId) : "",
            createdBy: item.createdBy,
            updatedBy: item.updatedBy ?? null,
            customFields: item.customFields ?? []
          };
        });
      setCourses(prev => mergeCourses(prev, mappedCourses));
    },
    onError: error => {
      console.error("Errore recupero corsi rejected training:", error);
    }
  });

  // ─── 6) APPROVED - TRAINING REQUEST ───
  //    Query key: ["externalTrain", userId, "approved"]
  useExternalTrainingQueryApproved({
    queryKey: ["externalTrain", String(userId), "approved", String(refreshKey)],
    queryParams: {
      learnerId: userId,
      corporateId,
      name,
      surname,
      status: "approved"
      // TODO: scommentare quando il backend supporterà i filtri
      // statusFilter, typeFilter, sortBy, sortDirection
    },
    enabled,
    onSuccess: (data: { content: GetPayloadPropsExternalTraining[] }) => {
      console.log("dati corsi 6:", data.content);
      const mappedCourses: CourseItem[] = data.content
        .sort((a, b) => Number(b.id) - Number(a.id))
        .map(item => {
          const status: CourseItem["status"] =
            item.status === "APPROVED"  ? "APPROVED"  :
              item.status === "REJECTED"  ? "REJECTED"  :
                "PENDING";

          return {
            id: Number(item.id),
            title: item.title,
            provider: item.provider ?? "-",
            startDate: item.startDate ?? "",
            endDate: item.endDate ?? "",
            status,
            type: item.type ?? "Iscrizione",
            duration: Number(item.durationMinutes),
            durationParticipation: Number(item.durationParticipation),
            source: item.source,
            area: Array.isArray(item.area) ? item.area : null,
            location: item.location,
            cost: item.cost,
            motivation: item.motivation,
            capability: Array.isArray(item.capability)? item.capability.map((c) => ({ id: Number(c.id), label: c.label })): [],
            businessTrip: item.businessTrip,
            campaign: item.campaign ?? "",
            instructor: item.instructor,
            trainingMode: modeMapV2.current[item.trainingMode] ?? "",
            plan: item.plan,
            description: item.description,
            campaignId: item.campaignId != null ? String(item.campaignId) : "",
            createdBy: item.createdBy,
            updatedBy: item.updatedBy ?? null,
            customFields: item.customFields ?? []
          };
        });
      setCourses(prev => mergeCourses(prev, mappedCourses));
    },
    onError: error => {
      console.error("Errore recupero corsi approved training:", error);
    }
  });
};
